import React, { Component, Fragment } from "react";
import {
  Button,
  Segment,
  Dropdown,
  Modal,
  Image,
  Form,
  Grid,
  Message,
  Confirm,
  Icon,
  Popup,
  Dimmer,
  Loader,
} from "semantic-ui-react";
import Dropzone from "react-dropzone";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import CardLayout from "../components/CardLayout";
import gql from "graphql-tag";
import client from "../store/apolloClient";

import { composeCardAlt } from "../store/actions/CardUIActions";

class UploadSymbol extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      confirmOpen: false,
      classOptions: [],
      styleOptions: [],
      teamOptions: [],
      colorOptions: [
        { value: 1, text: props.t("UPSY_IMGCOLOR_BW") },
        { value: 2, text: props.t("UPSY_IMGCOLOR_COL") },
      ],
      file: [{ preview: "", size: 0 }],
      card: this.props.card
        ? this.props.card
        : { id: 0, lemma: "Custom Images", img: "simcaa.png" },
      tmpFolder: "",
      urlImg: window.env.PathImages,
      imgStat: { width: 0, height: 0, size: 0 },
      word: this.props.card
        ? this.props.card.lemma || this.props.card.voice_master
        : "",
      style: 0,
      color: 1,
      class: 0,
      privatePhoto: 0,
      shareOptions: [
        { value: 0, text: props.t("PRLD_DROP_PRIVATE") },
        { value: 1, text: props.t("PRLD_DROP_PRIVACY") },
      ],
      error: { hidden: true, text: "" },
      message: { hidden: true, text: "", color: "green" },
      imageLoading: false,
      shareTeam: [],
      loadingUpload: false,
    };
  }

  componentDidMount() {
    // Fetch delle classi
    let localOptionsClass = this.props.classData.slice();
    let localClass;
    for (let i = 0; i < localOptionsClass.length; i++) {
      localOptionsClass[i] = {
        value: localOptionsClass[i].id,
        text: localOptionsClass[i].descclass,
      };
      if (localOptionsClass[i].text === "altro") {
        localClass = localOptionsClass[i].value;
      }
    }

    // Fetch degli stili
    let localOptionsStyle = this.props.styleData.slice();
    let localStyle;
    for (let i = 0; i < localOptionsStyle.length; i++) {
      localOptionsStyle[i] = {
        value: localOptionsStyle[i].id,
        text: localOptionsStyle[i].descstyle,
      };
      if (localOptionsStyle[i].text === "Indefinito") {
        localStyle = localOptionsStyle[i].value;
      }
    }

    // Fetch team
    let localOptionsTeam = this.props.team.slice();
    for (let i = 0; i < localOptionsTeam.length; i++) {
      localOptionsTeam[i] = {
        value: localOptionsTeam[i].team_id,
        text: localOptionsTeam[i].team_name,
      };
    }

    // Add share option if the user has the right permission
    let localShare = this.state.shareOptions.slice();
    if (
      this.props.user.user_permissions.can_manage_preload &&
      localShare.length === 2
    ) {
      localShare.push({ value: 2, text: this.props.t("PRLD_DROP_TEAM") });
      if (this.props.user.user_permissions.can_manage_staff) {
        localShare.push({ value: 3, text: this.props.t("PRLD_DROP_STAFF") });
      }
    }

    this.setState({
      classOptions: localOptionsClass,
      styleOptions: localOptionsStyle,
      teamOptions: localOptionsTeam,
      class: localClass,
      style: localStyle,
      shareOptions: localShare,
    });
  }

  // onDrop dell'immagine
  onDrop(files) {
    if (files.length === 0) {
      this.setState({
        error: {
          hidden: false,
          text: this.props.t("ERR_FILESIZE_EXCEED_FORMAT"),
        },
      });
    } else {
      let localImgStat = this.state.imgStat;
      localImgStat.size = files[0].size;
      this.setState(
        {
          file: files,
          error: { hidden: true, text: "" },
          imgStat: localImgStat,
        },
        () => {
          this.getPreviewImage();
        }
      );
    }
  }

  // Get full preview
  getPreviewImage() {
    let imgToSend = new FormData();
    imgToSend.append("file", this.state.file[0]);
    imgToSend.append("type", "preview");
    // imgToSend.append("custom", true);

    // let request = new Request(window.env.ApiImageUpload,{
    let request = new Request(window.env.GetSymbolPreview, {
      method: "POST",
      mimeType: "multipart/form-data",
      body: imgToSend,
    });

    this.setState({ imageLoading: true });

    fetch(request)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.statusCode === 999) {
          let textError =
            data.error + " associata a queste parole: " + data.duplicates;
          this.setState({
            error: { hidden: false, text: textError },
            imageLoading: false,
          });
        } else if (data.statusCode !== 200) {
          this.setState({
            error: { hidden: false, text: data.error.message },
            imageLoading: false,
          });
        } else {
          let localCard = this.state.card;
          localCard.img = data.body.key;

          let localImgStat = Object.assign({}, this.state.imgStat);
          localImgStat.width = data.body.OriginalWidth;
          localImgStat.height = data.body.OriginalHeight;
          this.setState({
            card: localCard,
            urlImg: window.env.S3Bucket,
            imgStat: localImgStat,
            imageLoading: false,
            // tmpFolder: data.time,
            // urlImg: window.env.TmpImage + data.time + "/",
          });
        }
      });
    // .catch(error => {
    //   console.log(error);
    // });
  }

  // Handle open/close of the modal
  openCloseModal() {
    if (this.state.modalOpen === true && this.props.mode === "upload") {
      this.setState(
        {
          modalOpen: !this.state.modalOpen,
          file: [{ preview: "", size: 0 }],
          imgStat: { width: 0, height: 0, size: 0 },
          word: "",
          privatePhoto: 0,
          shareTeam: [],
          error: { hidden: true, text: "" },
          urlImg: window.env.PathImages,
          card: { id: 0, lemma: "Custom Images", img: "simcaa.png" },
        },
        () => this.componentDidMount()
      );
    } else if (this.state.modalOpen === true && this.props.mode === "save") {
      this.setState(
        {
          modalOpen: !this.state.modalOpen,
          word: this.state.card.lemma,
          privatePhoto: 0,
          error: { hidden: true, text: "" },
        },
        () => this.componentDidMount()
      );
    } else {
      this.setState({
        modalOpen: !this.state.modalOpen,
        confirmOpen: false,
        word: this.props.card ? this.props.card.lemma : "",
        card: this.props.card ? this.props.card : this.state.card,
        privatePhoto:
          this.props.card && this.props.card.type_img
            ? this.props.card.type_img
            : 0,
        style:
          this.props.mode === "edit"
            ? this.props.card.idstyle
            : this.state.style,
        shareTeam:
          this.props.mode === "edit"
            ? this.props.card.share_team
            : this.state.shareTeam,
        color:
          this.props.mode === "edit"
            ? parseInt(this.props.card.imgcolor, 10)
            : this.state.color,
        class:
          this.props.mode === "edit"
            ? this.props.card.idclass
            : this.state.class,
      });
    }
  }

  // Handle mode
  handleMode() {
    if (this.props.mode === "edit") {
      this.edit();
    } else if (this.props.mode === "delete") {
      this.delete();
    } else {
      this.openCloseConfirm();
    }
  }

  // Handle open/close Confirm
  openCloseConfirm() {
    this.setState({ confirmOpen: !this.state.confirmOpen });
  }

  // Handle lemma change input
  wordChange(e) {
    this.setState({ word: e.target.value });
  }

  // Handle Dropdown form (style/color/class)
  dropdownChange(type, e, data) {
    if (type === "style") {
      this.setState({ style: data.value });
    } else if (type === "color") {
      this.setState({ color: data.value });
    } else if (type === "class") {
      this.setState({ class: data.value });
    } else if (type === "share") {
      this.setState({ privatePhoto: data.value, shareTeam: [] });
    }
  }

  // Handle multiple team select
  teamsChange(e, data) {
    this.setState({ shareTeam: data.value });
  }

  buildQueryInsert(substrValue = 0) {
    const voice_human = this.state.word.trim().toLowerCase();
    const mutation = gql`
      mutation InsertNewPreloadHeardword {
        insert_simcaa_t_custom_preload_headword(
          objects: {
            idlang: 4
            idclass: ${this.state.class}
            idstaff: ${this.props.user.idstaff}
            idstyle: ${this.state.style}
            imgcolor: "${this.state.color}"
            created_by: ${this.props.user.id}
            idteam: ${this.props.idteam}
            lexical_expr: ${voice_human.indexOf(" ") >= 0 ? 1 : 0} 
            symbol_sign: "${this.state.card.img.substring(substrValue)}"
            type_img: ${this.state.privatePhoto} 
            voice_human: "${voice_human}"
            share_team: [${this.state.shareTeam}]
            with_image: ${
              this.state.card.custom === true || this.props.mode === "upload"
                ? 1
                : 0
            }
            voice_master: "${voice_human.replace(/ .*/, "")}"
          }
        ) {
          affected_rows
          returning {
            voice_master
            voice_human
            symbol_sign
            lexical_expr
            with_image
          }
        }
      }
    `;
    return mutation;
  }

  // Main Upload or Save
  upload() {
    if (!this.state.loadingUpload) {
      this.setState({ loadingUpload: true });

      const voice_human = this.state.word.trim().toLowerCase();
      let localError = Object.assign({}, this.state.error);
      let localMessage = Object.assign({}, this.state.message);
      if (Object.values(this.state.imgStat).every((value) => value === 0)) {
        localError.hidden = false;
        localError.text = this.props.t("ERR_UPLOAD_FILE");
        this.setState({
          error: localError,
          confirmOpen: !this.state.confirmOpen,
          loadingUpload: false,
        });
      } else if (
        voice_human.length === 0 ||
        (this.state.shareTeam.length === 0 && this.state.privatePhoto === 2)
      ) {
        localError.hidden = false;
        localError.text = this.props.t("ERR_UPLOAD_SYMBOL");
        this.setState({
          error: localError,
          confirmOpen: false,
          loadingUpload: false,
        });
      } else {
        let voice_human = this.state.word.trim().toLowerCase();
        let img = this.state.card.img.substring(8);
        const query = gql`
      {
        simcaa_t_custom_preload_headword(where: {_and: [
          {symbol_sign: {_eq: "${img}"}},
          {voice_human: {_eq: "${voice_human}"}},
          {idteam: {_eq: ${this.props.idteam}}},
          {idstaff: {_eq: ${this.props.user.idstaff}}},
          {created_by: {_eq: ${this.props.user.id}}}
        ]}) {
          voice_human
        }
        arasaac_caa_t_headwords(where: {_and: [
          {xref: {symbol: {symbol_sign: {_eq: "${img}"}}}},
          {fulltext: {voice_human: {_eq: "${voice_human}"}}}
        ]}) {
          fulltext {
            voice_human
          }
        }
      }
      `;

        client.query({ query }).then((duplicates) => {
          if (
            Object.values(duplicates.data).every((item) => item.length === 0)
          ) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const body = {
              // folder: "tmp/",
              // filename: this.state.card.img.substring(4),
              folder: "preview/",
              filename: this.state.card.img.substring(8),
              copyTo: "custom",
            };

            var requestOptions = {
              method: "POST",
              headers: myHeaders,
              body: JSON.stringify(body),
              redirect: "follow",
            };

            fetch(window.env.CopyFile, requestOptions)
              .then((response) => response.json())
              .then((result) => {
                if (result.code !== 200) {
                  this.setState({
                    error: {
                      hidden: false,
                      text: result.error,
                    },
                  });
                } else {
                  const mutation = this.buildQueryInsert(8);
                  client
                    .mutate({ mutation })
                    .then((data) => {
                      const returning =
                        data.data.insert_simcaa_t_custom_preload_headword
                          .returning[0];
                      if (
                        this.props.cards.findIndex(
                          (item) => item.voice_master === returning.voice_master
                        ) >= 0
                      ) {
                        const addToAlt = [
                          {
                            voice_human: returning.voice_human,
                            voice_master: returning.voice_master,
                            img: returning.symbol_sign,
                            complex: returning.lexical_expr,
                            custom: returning.with_image === 1 ? true : false,
                          },
                        ];
                        this.props.composeCardAlt(addToAlt);
                      }
                      localMessage.hidden = !localMessage.hidden;
                      localMessage.text = this.props.t("UPSY_UPLOAD_SUCCESS");
                      this.setState({
                        message: localMessage,
                        confirmOpen: false,
                        loadingUpload: false,
                      });
                      setTimeout(() => {
                        this.setState({
                          message: { hidden: true, text: "", color: "green" },
                        });
                        this.openCloseModal();
                      }, 2000);
                    })
                    .catch((error) => console.log(error));
                }
              })
              .catch((error) => console.log("error", error));
          } else {
            this.setState({
              error: {
                hidden: false,
                text: this.props.t("ERR_DUPLICATE_RECORD"),
              },
              loadingUpload: false,
              confirmOpen: !this.state.confirmOpen,
            });
          }
        });
      }
    }
  }

  // Check for duplicates and call upload
  save() {
    if (this.state.shareTeam.length === 0 && this.state.privatePhoto === 2) {
      let localError = Object.assign({}, this.state.error);
      localError.hidden = false;
      localError.text = this.props.t("ERR_UPLOAD_SYMBOL");
      this.setState({
        error: localError,
        confirmOpen: false,
      });
    } else {
      let voice_human = this.state.word.trim().toLowerCase();
      const query = gql`
    {
      simcaa_t_custom_preload_headword(where: {_and: [
        {symbol_sign: {_eq: "${this.state.card.img}"}},
        {voice_human: {_eq: "${voice_human}"}},
        {idteam: {_eq: ${this.props.idteam}}},
        {idstaff: {_eq: ${this.props.user.idstaff}}},
        {created_by: {_eq: ${this.props.user.id}}}
      ]}) {
        voice_human
      }
      arasaac_caa_t_headwords(where: {_and: [
        {xref: {symbol: {symbol_sign: {_eq: "${this.state.card.img}"}}}},
        {fulltext: {voice_human: {_eq: "${voice_human}"}}}
      ]}) {
        fulltext {
          voice_human
        }
      }
    }
    `;

      client
        .query({ query })
        .then((duplicates) => {
          if (
            Object.values(duplicates.data).every((item) => item.length === 0)
          ) {
            const mutation = this.buildQueryInsert();
            client
              .mutate({ mutation })
              .then((data) => {
                const returning =
                  data.data.insert_simcaa_t_custom_preload_headword
                    .returning[0];

                if (
                  this.props.cards.findIndex(
                    (item) => item.voice_master === returning.voice_master
                  ) >= 0
                ) {
                  const addToAlt = [
                    {
                      voice_human: returning.voice_human,
                      voice_master: returning.voice_master,
                      img: returning.symbol_sign,
                      complex: returning.lexical_expr,
                      custom: returning.with_image === 1 ? true : false,
                    },
                  ];
                  this.props.composeCardAlt(addToAlt);
                }
                let localMessage = Object.assign({}, this.state.message);
                localMessage.hidden = !localMessage.hidden;
                localMessage.text = this.props.t("UPSY_UPLOAD_SUCCESS");
                this.setState({ message: localMessage, confirmOpen: false });
                setTimeout(() => {
                  this.setState({
                    message: { hidden: true, text: "", color: "green" },
                  });
                  this.openCloseModal();
                }, 2000);
              })
              .catch((error) => console.log(error));
          } else {
            this.setState({
              error: {
                hidden: false,
                text: this.props.t("ERR_DUPLICATE_RECORD"),
              },
              confirmOpen: !this.state.confirmOpen,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  // Edit the currend preload record
  edit() {
    let voice_human = this.state.word.trim().toLowerCase();
    let voice_master = voice_human.replace(/ .*/, "");
    let lexical_expr = voice_human.indexOf(" ") >= 0 ? 1 : 0;
    let idclass = this.state.class;
    let type_img = this.state.privatePhoto;
    let imgcolor = this.state.color;
    let idstyle = this.state.style;

    const mutation = gql`
      mutation UpdatePreloadHeadword {
        update_simcaa_t_custom_preload_headword(
          where: { id: { _eq: ${this.state.card.id} } }
          _set: {
            voice_master: "${voice_master}",
            voice_human: "${voice_human}",
            lexical_expr: ${lexical_expr},
            idclass: ${idclass},
            idstyle:  ${idstyle},
            imgcolor: "${imgcolor}",
            type_img: ${type_img},
            share_team: [${this.state.shareTeam}]
          }
        ) {
          affected_rows
        }
      }
    `;

    if (
      voice_human.length === 0 ||
      (this.state.shareTeam.length === 0 && this.state.privatePhoto === 2)
    ) {
      let localError = this.state.error;
      localError.hidden = false;
      localError.text = this.props.t("ERR_UPLOAD_SYMBOL");
      this.setState({
        error: localError,
        // confirmOpen: !this.state.confirmOpen,
        confirmOpen: false,
      });
    } else {
      client
        .mutate({ mutation })
        .then((data) => {
          this.openCloseModal();
          this.props.refresh();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  // Delete the current preload record
  delete() {
    const query = gql`
    {
      simcaa_t_custom_preload_headword(where: {_and: [
        {symbol_sign: {_eq: "${this.state.card.img}"}},
        {id: {_neq: ${this.state.card.id}}}
      ]}) {
        voice_human
      }
      arasaac_caa_t_headwords(where: {_and: [
        {xref: {symbol: {symbol_sign: {_eq: "${this.state.card.img}"}}}},
        {fulltext: {voice_human: {_eq: "${this.state.word}"}}}
      ]}) {
        fulltext {
          voice_human
        }
      }
    }
    `;

    const mutation = gql`
      mutation DeletePreloadRecord {
        delete_simcaa_t_custom_preload_headword(where: { id: { _eq: ${this.state.card.id} } }) {
          affected_rows
        }
      }
    `;

    client
      .mutate({ mutation })
      .then((data) => {
        client.query({ query }).then((duplicates) => {
          if (
            Object.values(duplicates.data).every((item) => item.length === 0) &&
            this.props.card.custom === true
          ) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const body = {
              folder: "custom/",
              filename: this.state.card.img,
            };

            var requestOptions = {
              method: "POST",
              headers: myHeaders,
              body: JSON.stringify(body),
              redirect: "follow",
            };

            fetch(window.env.DeleteFile, requestOptions)
              .then((response) => response.json())
              .then((data) => {
                this.openCloseModal();
                this.props.refresh();
              });
          } else {
            this.openCloseModal();
            this.props.refresh();
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // MAIN RENDER
  render() {
    const { t } = this.props;

    // Render trigger modal based on props.type
    let triggerModal;
    if (this.props.type === "dropdown") {
      triggerModal = (
        <Dropdown.Item
          style={this.props.style}
          className={"icon-pointer dropdown-item-hover " + this.props.className}
          onClick={this.openCloseModal.bind(this)}
        >
          {t("HOME_NAVBAR_MANAGE_SYMBOL")}
        </Dropdown.Item>
      );
    } else if (this.props.type === "button") {
      triggerModal = (
        <Button
          style={this.props.style}
          color={this.props.buttonColor}
          className={"icon-pointer " + this.props.className}
          onClick={this.openCloseModal.bind(this)}
        >
          {t(this.props.buttonTranslateText)}
        </Button>
      );
    } else if (this.props.type === "icon" && this.props.mode === "upload") {
      triggerModal = (
        <Popup
          trigger={
            <Icon
              name="upload"
              bordered
              inverted
              color="teal"
              size="large"
              className={"icon-pointer " + this.props.className}
              style={this.props.style}
              onClick={this.openCloseModal.bind(this)}
            />
          }
          content={t("POPUP_IMPORT")}
        />
      );
    } else if (this.props.type === "icon" && this.props.mode === "save") {
      triggerModal = (
        <Popup
          trigger={
            <Icon
              name="save"
              bordered
              inverted
              color="teal"
              size="large"
              className={"icon-pointer " + this.props.className}
              style={this.props.style}
              disabled={this.props.card.lock === "lock" ? false : true}
              onClick={this.openCloseModal.bind(this)}
            />
          }
          content={t("POPUP_SAVE")}
        />
      );
    }

    let dropzoneRef;
    let imgSrcUrl = this.state.card.custom
      ? window.env.CustomImage + this.state.card.img
      : window.env.PathImages + this.state.card.img;

    const warningDelete = (
      <Message warning>
        <p>{t("UPSY_DELETE_CONFIRM_PUBLIC")}</p>
      </Message>
    );

    // MAIN RENDER RETURN
    if (this.props.mode === "delete") {
      return (
        <Modal trigger={triggerModal} open={this.state.modalOpen}>
          <Modal.Header>{t("UPSY_SELECTIMG")}</Modal.Header>
          <Modal.Content>
            {t("UPSY_DELETE_CONFIRM")}
            <br />
            {this.props.card.type_img > 1 ? warningDelete : null}
          </Modal.Content>
          <Modal.Actions>
            <Button.Group>
              <Button positive onClick={this.delete.bind(this)}>
                {t(this.props.buttonActionTranslateText)}
              </Button>
              <Button.Or />
              <Button negative onClick={this.openCloseModal.bind(this)}>
                {t("UPSY_CANCEL")}
              </Button>
            </Button.Group>
          </Modal.Actions>
        </Modal>
      );
    }

    return (
      <Modal trigger={triggerModal} open={this.state.modalOpen}>
        <Modal.Header>{t("UPSY_SELECTIMG")}</Modal.Header>
        <Modal.Content>
          {this.state.imageLoading ? (
            <Dimmer active>
              <Loader>Caricamento immagine...</Loader>
            </Dimmer>
          ) : (
            <Fragment>
              <Message negative hidden={this.state.error.hidden}>
                <Message.Header>{t("ERR_UPLOAD_SYMBOL_HEADER")}</Message.Header>
                <p>{this.state.error.text}</p>
              </Message>
              <Message
                color={this.state.message.color}
                hidden={this.state.message.hidden}
              >
                <p>{this.state.message.text}</p>
              </Message>
              <Form>
                <Form.Field>
                  <label>{t("UPSY_WORD")}</label>
                  <input
                    placeholder={t("UPSY_WORD")}
                    value={this.state.word}
                    onChange={this.wordChange.bind(this)}
                  />
                  {t("UPSY_WORD_MASTER")}:
                  <b> {this.state.word.split(" ")[0]}</b>
                </Form.Field>
                <Form.Field width={6}>
                  <label>{t("UPSY_CLASS")}</label>
                  <Dropdown
                    placeholder={t("UPSY_CLASS")}
                    selection
                    options={this.state.classOptions}
                    value={this.state.class}
                    onChange={this.dropdownChange.bind(this, "class")}
                  />
                </Form.Field>
                <Form.Field width={6}>
                  <label>{t("UPSY_IMGSHARE")}</label>
                  <Dropdown
                    placeholder={t("UPSY_IMGSHARE")}
                    selection
                    options={this.state.shareOptions}
                    value={this.state.privatePhoto}
                    onChange={this.dropdownChange.bind(this, "share")}
                  />
                </Form.Field>
                {this.state.privatePhoto === 2 ? (
                  <Form.Field width={6}>
                    {/* <label>{t("UPSY_IMGTYPE")}</label> */}
                    <Dropdown
                      placeholder={t("UPSY_IMGSHARE")}
                      selection
                      multiple
                      options={this.state.teamOptions}
                      value={this.state.shareTeam}
                      onChange={this.teamsChange.bind(this)}
                    />
                  </Form.Field>
                ) : null}
                <Form.Field width={6}>
                  <label>{t("UPSY_IMGCOLOR")}</label>
                  <Dropdown
                    placeholder={t("UPSY_IMGCOLOR")}
                    selection
                    options={this.state.colorOptions}
                    value={this.state.color}
                    onChange={this.dropdownChange.bind(this, "color")}
                  />
                </Form.Field>
                <Form.Field width={6}>
                  <label>{t("UPSY_IMGSTYLE")}</label>
                  <Dropdown
                    placeholder={t("UPSY_IMGCOLOR")}
                    selection
                    options={this.state.styleOptions}
                    value={this.state.style}
                    onChange={this.dropdownChange.bind(this, "style")}
                  />
                </Form.Field>
                {this.props.mode !== "upload" ? (
                  <Form.Field>
                    <label>Image</label>
                    <Image size="small" src={imgSrcUrl} />
                  </Form.Field>
                ) : (
                  <Fragment>
                    <Dropzone
                      ref={(node) => {
                        dropzoneRef = node;
                      }}
                      accept="image/jpeg, image/png"
                      style={{ display: "none" }}
                      onDrop={this.onDrop.bind(this)}
                      maxSize={500000}
                    />
                    <Button
                      onClick={() => {
                        dropzoneRef.open();
                      }}
                    >
                      {t("UPSY_OPENDIALOG")}
                    </Button>
                    <Image
                      hidden
                      src={this.state.urlImg + this.state.card.img}
                      id="imgTmp"
                    />
                    <br />
                    <Segment vertical>
                      {t("UPSY_WIDTH")}: {this.state.imgStat.width} px
                    </Segment>
                    <Segment vertical>
                      {t("UPSY_HEIGHT")}: {this.state.imgStat.height} px
                    </Segment>
                    <Segment vertical>
                      {t("UPSY_SIZE")}: {this.state.imgStat.size} byte
                    </Segment>
                    <Grid padded>
                      <Grid.Row columns="equal">
                        <Grid.Column>
                          <CardLayout
                            Card={this.state.card}
                            isTypo={false}
                            imgFullWidth={false}
                            mode={true}
                            posInput="bottom"
                            sizeInput="small"
                            styleInput="normal"
                            formatInput="freeInput"
                            colorTextInput="#000000"
                            colorBackgroundInput="#FFFFFF"
                            weightInput="weightNormalInput"
                            decorationInput="decorationNormalInput"
                            fontStyleInput="styleNormalInput"
                            imgSize="small"
                            imgPadding="imgpadding1"
                            urlImg={this.state.urlImg}
                          />
                        </Grid.Column>
                        <Grid.Column>
                          <CardLayout
                            Card={this.state.card}
                            isTypo={false}
                            imgFullWidth={false}
                            mode={true}
                            posInput="bottom"
                            sizeInput="small"
                            styleInput="normal"
                            formatInput="freeInput"
                            colorTextInput="#000000"
                            colorBackgroundInput="#FFFFFF"
                            weightInput="weightNormalInput"
                            decorationInput="decorationNormalInput"
                            fontStyleInput="styleNormalInput"
                            imgSize="tiny"
                            imgPadding="imgpadding1"
                            urlImg={this.state.urlImg}
                          />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Fragment>
                )}
              </Form>
              <Message negative hidden={this.state.error.hidden}>
                <Message.Header>{t("ERR_UPLOAD_SYMBOL_HEADER")}</Message.Header>
                <p>{this.state.error.text}</p>
              </Message>
              <Message
                color={this.state.message.color}
                hidden={this.state.message.hidden}
              >
                <p>{this.state.message.text}</p>
              </Message>
              <Confirm
                open={this.state.confirmOpen}
                header="Conferma upload"
                // content={t("HOWTO_UPLOAD_SYMBOL")
                //   .split("\n")
                //   .map((line, key) => (
                //     <p key={key}>{line}</p>
                //   ))}
                content={
                  <div style={{ padding: 20 }}>
                    <h3>
                      {t("UPSY_WORD_MASTER")}:{" "}
                      <b>{this.state.word.split(" ")[0]}</b>
                    </h3>
                    <h4 style={{ fontWeight: "normal" }}>
                      {t("UPSY_CANCEL_TEXT")}
                    </h4>
                  </div>
                }
                cancelButton={t("UPSY_CANCEL")}
                onConfirm={
                  this.props.mode === "save"
                    ? this.save.bind(this)
                    : this.upload.bind(this)
                }
                onCancel={this.openCloseConfirm.bind(this)}
              />
            </Fragment>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button.Group>
            <Button positive onClick={this.handleMode.bind(this)}>
              {t(this.props.buttonActionTranslateText)}
            </Button>
            <Button.Or />
            <Button negative onClick={this.openCloseModal.bind(this)}>
              {t("UPSY_CANCEL")}
            </Button>
          </Button.Group>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    cards: state.chapterContentData,
    team: state.userTeamData,
    styleData: state.styleData,
    classData: state.classData,
    idteam: state.filterValue,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    composeCardAlt: (array) => dispatch(composeCardAlt(array)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(UploadSymbol));



// WEBPACK FOOTER //
// ./src/containers/UploadSymbol.js